import styled, { css, keyframes } from 'styled-components'
// import IconEdit from '../../../assets/icons/icon-edit.svg'
// import IconRemove from '../../../assets/icons/icon-remove.svg'

const showContent = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

const showFullText = keyframes`
  0% {
    transform: translateX(0%);
  }
  90% {
    transform: translateX(-100%);
  }
  95% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(0%);
  }
`

export const PageContent = styled.div`
  transition: all 400ms ease-in-out;
  animation: ${showContent} 1000ms;
`

export const ProfileTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  color: #555;
`

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  /* background-color: gold; */
`

export const CardWrapper = styled.div`
  /* min-width: 400px; */
  width: calc(50% - 16px);
  position: relative;

  /* background-color: tomato; */

  @media (max-width: 860px) {
    width: 100%;

    .col-6 {
      width: 50%;
    }
  }
`

export const CardBox = styled.div`
  background: #ffffff;
  padding: 16px 16px 16px 24px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  /* margin-bottom: 20px; */

  /* background-color: violet; */

  .endereco-card-title {
    font-size: 16px;
    display: block;
    margin-bottom: 6px;
  }

  .endereco-card-title.logradouro {
  }

  .endereco-card-title span {
    font-weight: normal;
  }

  .endereco-card-description {
    /* margin-bottom: 8px; */
  }

  @media (max-width: 1170px) {
    .perfil-box {
      padding: 30px 20px 10px 20px;
    }
  }

  @media (min-width: 1170px) and (max-width: 1360px) {
    .endereco-card-title {
      font-size: 14px;
    }

    .endereco-card-description {
      font-size: 14px;
    }
  }
`

export const CardConfig = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: right;
`

export const CardLink = styled.a`
  transition: all 400ms;
  cursor: pointer;

  &:nth-child(2) {
    margin-left: 10px;
  }

  & img {
    width: 20px;
    height: 20px;

    &:hover {
      filter: invert(22%) sepia(78%) saturate(2710%) hue-rotate(341deg)
        brightness(88%) contrast(96%);
    }
  }
`

export const CardAddressType = styled.h3`
  font-size: 16px;
  display: block;
  margin-bottom: 6px;

  &.apelido {
    max-width: 85%;
    overflow: hidden;
    white-space: nowrap;

    p {
      text-overflow: ellipsis;
      overflow-x: hidden;
    }
  }
`
export const Address = styled.h3`
  ${({ theme, cropText }) => css`
    width: 100%;
    display: inline-block; /* important */
    white-space: nowrap;
    overflow: hidden;

    p {
      text-overflow: ellipsis;
      overflow-x: hidden;
    }

    ${!!cropText &&
    css`
      &:hover,
      &:focus {
        p {
          display: inline-block;
          margin-bottom: -4px;
          animation: ${showFullText} 7s linear;
        }
      }
    `}
  `}
`

export const AddressDescription = styled.p`
  ${({ theme, cropText }) => css`
    width: 100%;
    display: inline-block; /* important */
    white-space: nowrap;
    overflow: hidden;

    p {
      text-overflow: ellipsis;
      overflow-x: hidden;
    }

    ${!!cropText &&
    css`
      &:hover,
      &:focus {
        p {
          display: inline-block;
          margin-bottom: -4px;
          animation: ${showFullText} 7s linear;
        }
      }
    `}
  `}
`

export const ProfileBox = styled.div`
  background: #ffffff;
  border: 1px solid #e5e5e5;
`

export const ProfileBoxFooter = styled.div`
  margin: 10px 0 20px 0;

  @media (max-width: 1170px) {
    display: flex;
    flex-direction: column;
  }
`

export const ButtonAddNewAddress = styled.button`
  ${({ theme }) => css`
    border-radius: 4px;
    margin-top: 8px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    padding: 12px 16px;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &:hover {
      background: #a71e26;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: $MEDIA-IPAD) {
      font-size: 14px;
    }
  `}
`
